import React from 'react';

export default function Header() {
  return (
    <header className="border-b border-orange-100 bg-white sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 h-16 flex items-center">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-2xl bg-gradient-to-br from-orange-400 to-pink-400 flex items-center justify-center shadow-lg shadow-orange-200 text-xl">
            🐱
          </div>
          <div>
            <h1 className="text-lg font-extrabold text-slate-800 tracking-tight leading-none">
              MeowProxy
            </h1>
            <span className="text-xs font-semibold text-orange-400 tracking-widest uppercase">
              Checker
            </span>
          </div>
        </div>
      </div>
    </header>
  );
}